// import React from "react";

// const AboutBanner = () => {
//   return (
//     <section
//       className="relative w-full h-[80vh] bg-cover bg-center flex items-center justify-center"
//       style={{
//         backgroundImage:
//           "url('http://bakelore.com/images/about-banner.jpg')", // 🔹 Replace with your banner image URL
//       }}
//     >
//       {/* Overlay */}
//       <div className="absolute inset-0 bg-black/30"></div>

//       {/* Content */}
//       <div className="relative z-10 text-center text-white px-6">
//         <h1 className="text-5xl md:text-6xl font-bold mb-8 drop-shadow-lg">
//           About Us
//         </h1>
//         <button className="bg-[#d49393] hover:bg-[#c37c7c] transition-all duration-300 text-white font-medium py-3 px-10 rounded-md shadow-md">
//           ORDER NOW
//         </button>
//       </div>
//     </section>
//   );
// };

// export default AboutBanner;

import React from "react";
import { Link } from "react-router-dom";

const AboutBanner = () => {
  return (
    <section
      className="relative w-full h-[80vh] bg-cover bg-center flex items-center justify-center font-body"
      style={{
        backgroundImage: "url('http://bakelore.com/images/about-banner.jpg')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/30"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        <h1 className="text-5xl md:text-6xl font-heading mb-8 drop-shadow-lg tracking-wide text-[#C08B89]">
          About Us
        </h1>

        <Link to="#" style={{ textDecoration: "none" }}>
          <button className="bg-[#C08B89] hover:bg-[#C08B89] transition-all duration-300 text-white font-medium py-3 px-10 rounded-md shadow-md uppercase tracking-wider">
            Order Now
          </button>
        </Link>
      </div>
    </section>
  );
};

export default AboutBanner;
